import React, {useState, useEffect} from 'react';
import {
  FormControl,
  FormHelperText,
  Input,
  TextareaAutosize,
  Modal
} from '@mui/material';
import CloseButton from '../../../buttons/closeButton'
import GreenSubmitButton from '../../../buttons/greenSubmitButton';
import { inject, observer } from "mobx-react";
import Utils from '../../../Utils';
import AddressAutocomplete from '../../address/AddressAutocomplete';
import "./AddOrEditAddressModal.css";
import Box from '@mui/material/Box';

// Translations
import _useTranslate from '../../../hooks/_useTranslate';

let streetElement;
let streetNumberElement;
let cityElement;
let postcodeElement;
let apartmentElement;
let addressCommentElement;

const style = {
  position: 'absolute',
   width: {
    xs: '100%',
    sm: '80%', 
    md: 600,  
  },  
  top: {xs: 60, sm: '50%'},
  left: {xs: 0, sm: '50%'},
  transform: {sm: 'translate(-50%, -50%)'}, 
  bgcolor: 'background.paper',
  border: '2px solid var(--border-color)',
  borderRadius: 4,
  boxShadow: 24,
  p: 4,
};

const AddOrEditaddressModal = ({visible, close, itemToEdit, itemIndex, companyId, setAddresses, feathersStore})=> { 

  let common = _useTranslate(feathersStore.language, "common");
  let account = _useTranslate(feathersStore.language, "account");  
  
  const [otherSelected, setOther] = useState(false);
  const [homeSelected, setHome] = useState(false);
  const [workSelected, setWork] = useState(false);
  const [header, setHeader] = useState("");
  const [title, setTitle] = useState("Home");
  const [streetNumber, setStreetNumber] = useState("");
  const [street, setStreet] = useState("");
  const [apartment, setApartment] = useState(""); 
  const [addressComment, setAddressComment] = useState(""); 
  const [postcode, setPostcode] = useState(""); 
  const [city, setCity] = useState("");
  // Exact coordinates, captured only when an autocomplete suggestion is picked.
  const [latitude, setLatitude] = useState(0);
  const [longitude, setLongitude] = useState(0);
  const [active, setActive] = useState(false); 
  const [streetError, setStreetError] = useState(false);
  const [streetNumberError, setStreetNumberError] = useState(false);  
  const [cityError, setCityError] = useState(false);
  const [loading, setLoading] = useState(false); 

  
  useEffect(() => {    
    setHeader(account.addNewAddress);
    if(Object.keys(itemToEdit).length !== 0 && itemToEdit.constructor === Object){
      setHeader(account.modalHeaderUpdate);
      setTitle(itemToEdit.title);
      switch(itemToEdit.title){
        case "Home" : case "Οικία" : setHome(true); //accept both the canonical and the legacy stored title
        break;
        case "Work" : case "Έργασία" : setWork(true);
        break;
        case "Other" : case "Άλλη Τοποθεσία" : setOther(true);
        break;
      }
      setStreet(itemToEdit.street);
      setStreetNumber(itemToEdit.streetNumber);
      setCity(itemToEdit.city);
      setLatitude(itemToEdit.latitude || 0);
      setLongitude(itemToEdit.longitude || 0);
      setPostcode(itemToEdit.postcode);
      setApartment(itemToEdit.apartment);
      setAddressComment(itemToEdit.addressComment);
      setActive(itemToEdit.active);
    }   
  }, [feathersStore.language, account])

  const PressOther = ()=> {
    setOther(true);
    setHome(false);
    setWork(false);
    setTitle('Other')
  }

  const PressHome = ()=> {
    setOther(false);
    setHome(true);
    setWork(false);
    setTitle('Home')
  }

  const PressWork = ()=> {
    setOther(false);
    setHome(false);
    setWork(true);
    setTitle('Work');
  }

  const clearCoordinates = () => { setLatitude(0); setLongitude(0); };

  // Free typing invalidates a previously picked pin.
  const onStreetInput = (text) => {
    setStreet(text);
    streetValidation(text);
    clearCoordinates();
  };

  // Company addresses store the city as FREE TEXT (unlike the account modal,
  // which stores a numeric settings.citys id), so write the resolved label.
  const onAddressResolved = (resolved) => {
    setStreet(resolved.street || '');
    streetValidation(resolved.street || '');
    if(resolved.streetNumber){ setStreetNumber(resolved.streetNumber); streetNumberValidation(resolved.streetNumber); }
    if(resolved.postcode) setPostcode(resolved.postcode);
    if(resolved.cityLabel){ setCity(resolved.cityLabel); cityValidation(resolved.cityLabel); }
    setLatitude(resolved.latitude);
    setLongitude(resolved.longitude);
  };

  const onChangeText = key => (event) => {
    
    switch(key){
      case "street" : {setStreet(event.target.value); streetValidation(event.target.value);}
      break;
      // A hand-edited number is a different building than the picked pin.
      case "streetNumber" : {setStreetNumber(event.target.value); streetNumberValidation(event.target.value); clearCoordinates();}
      break;
      case "city" : {setCity(event.target.value); cityValidation(event.target.value);}
      break;
      case "postcode" : setPostcode(event.target.value); 
      break;
      case "apartment" : setApartment(event.target.value);
      break;
      case "addressComment" : setAddressComment(event.target.value);
      break;
    }
  };

  const enterPressed = key => (ev) => {   
    if (ev.key === 'Enter') {
      switch(key){
        case "street" : streetNumberElement.focus();
        break;
        case "streetNumber" : cityElement.focus();
        break;
        case "city" : postcodeElement.focus();
        break;
        case "postcode" : apartmentElement.focus();
        break;
        case "apartment" : addressCommentElement.focus();
        break;
        case "addressComment" : streetElement.focus();
        break;
      }
        
    }
  }

  const streetValidation = val => {
    if (!Utils.validateNonEmpty(val) ) {
      setStreetError(true);
    }else{
     setStreetError(false);
   }
  }

  const streetNumberValidation = val => {
    if (!Utils.validateNonEmpty(val) ) {      
      setStreetNumberError(true);
    }else{
     setStreetNumberError(false);
   }
  }

  const cityValidation = val => {
    if (!Utils.validateNonEmpty(val) ) {
      setCityError(true);
    }else{
     setCityError(false);
   }
  }

  const saveAddress = async () => {
    setLoading(true);  
    const company = await feathersStore.getCompany(companyId);   
    let clonedAddresses=[...company?.addresses];         
    // This literal ENUMERATES its keys, so lat/lng must be listed here or they
    // are silently dropped on the next edit-save.
    const data = { city, street,  streetNumber, postcode, active, latitude, longitude};
    if(Object.keys(itemToEdit).length !== 0 && itemToEdit.constructor === Object){    
      Object.assign(data, {active: itemToEdit.active})           
      clonedAddresses.splice(itemIndex, 1, data);
    }else { //new address
      clonedAddresses.forEach(i => Object.assign(i, {active: false}))
      Object.assign(data, {active: true})
      clonedAddresses.push(data);  
    }      
    try{
      await feathersStore.patchCompanyAddresses( companyId, [...clonedAddresses]);
      setLoading(false);         
      setAddresses([...clonedAddresses])
      alert(common.updateSuccess);
      close();
    }catch (error){
      setLoading(false);   
      alert(common.updateError + `:  ${error.message}`)
    }
  };

return(
  <section>    
    <Modal     
      open={visible}
      onClose={close}
      aria-labelledby="address-edit-modal"
      aria-describedby="modal-for-editing-an-address"
    >
    <Box sx={style}>
      <div className="add-address-container">
        <div className="address-modal-header">
          <div className="edit-address-title">
            {header}
          </div>
          <div className="edit-address-close-button">
            <CloseButton onClick={close} aria-labelledby='Close'/> 
          </div>          
        </div>      
        <a style={{color: 'var(--secondaryText)'}}>{account.helperText}</a>
        <FormControl style={{width: '80%'}}>
          {/* Places-backed street field; a tenant with no GOOGLE_MAPS_KEY gets
              exactly the previous plain input. */}
          <AddressAutocomplete
            value={street}
            error={streetError}
            helperText={streetError ? common.streetError : ''}
            inputRef={r => {
              streetElement = r;
            }}
            aria-label='street'
            onInputChange={onStreetInput}
            onResolved={onAddressResolved}
            onKeyPress={enterPressed("street")}
            placeholder={common.street + "*"}
            variant="standard"
          />
        </FormControl>
        <FormControl style={{width: '80%'}}> 
          <Input
            value={streetNumber}     
            error={streetNumberError}
            inputRef={r => {
              streetNumberElement = r;
            }}
            aria-label='street number'
            onChange={onChangeText("streetNumber")}              
            onKeyPress={enterPressed("streetNumber")}                
            placeholder={common.streetNumber + "*"}
          />
          {streetNumberError && <FormHelperText id="component-error-text" >{common.streetNumberError}</FormHelperText>}
        </FormControl>        
        <FormControl style={{width: '80%'}}> 
          <Input
            value={city}     
            error={cityError}
            inputRef={r => {
              cityElement = r;
            }}
            aria-label='city'
            onChange={onChangeText("city")}              
            onKeyPress={enterPressed("city")}                
            placeholder={common.city + "*"}
          />
          {cityError && <FormHelperText id="component-error-text" >{common.cityError}</FormHelperText>}
        </FormControl>
        <FormControl style={{width: '80%'}}> 
          <Input
            value={postcode}         
            inputRef={r => {
              postcodeElement = r;
            }}
            aria-label='postcode'
            onChange={onChangeText("postcode")}              
            onKeyPress={enterPressed("postcode")}                
            placeholder={common.postcode + "*"}
          />       
        </FormControl>         
        <GreenSubmitButton   
        aria-labelledby='Save'      
          title={common.save}
          loading={loading}
          disabled={streetError || streetNumberError || cityError} 
          onClick={saveAddress}  
        /> 
      </div>
    </Box>
    </Modal>
  </section>
  )
}

export default inject('feathersStore')(observer(AddOrEditaddressModal));